import { getJSON } from "@js/helpers/communication.js";

export const studioOpensOverviewByPrivacy = (stat_or_slice_id) => (dispatch, getState) => {

  dispatch({ type: OPENS_STARTED, stat_or_slice_id: stat_or_slice_id });

  let url = Routes.api_v2_statistics_path(stat_or_slice_id);

  getJSON(url, (data, err) => {
    if ( err || !data.success ) {
      dispatch({ type: OPENS_FAILURE, error_message: err || data.error_message });
      return;
    }

    dispatch({ type: OPENS_SUCCESS, summary: data.data });
  });

};

export const OPENS_STARTED = "OPENS_STARTED";
export const OPENS_FAILURE = "OPENS_FAILURE";
export const OPENS_SUCCESS = "OPENS_SUCCESS";
export const OPENS_ABORTED = "OPENS_ABORTED";
